import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { motion } from "motion/react"
import NotificationItem from "../../../../features/profile/NotificationItem"
import { useRequest } from "../../../../hooks/useRequest"
import { openAuth } from "../../../../lib/openAuth"
import { userStore } from "../../../../store/userStore"
import { Notification } from "../../../../types/entities/notification"

const DISPLAY = "'Tilda Sans', sans-serif"
const BODY = "'Manrope', sans-serif"

export default function Notifications() {
    const { request, requestData } = useRequest()
    const { user, setUnreadMessages } = userStore()
    const navigate = useNavigate()
    const [items, setItems] = useState<Notification[]>([])
    const [loading, setLoading] = useState(false)

    const loadMessages = async () => {
        const data = await request<Notification[]>("GET", "user/message")
        const list = Array.isArray(data) ? data : []
        setItems(list)
        setUnreadMessages(list.filter(item => !item.read).length)
    }

    const markAsRead = async (id: string) => {
        const res = await requestData({ type: "PUT", path: `user/message/${id}/read`, disableError: true })
        if (res.status === "success") {
            setItems(prev => {
                const next = prev.map(item => (item.id === id ? { ...item, read: true } : item))
                setUnreadMessages(next.filter(item => !item.read).length)
                return next
            })
        }
    }

    useEffect(() => {
        if (!user) {
            // replace + фон на профиль: закрытие auth не возвращает сюда в цикл редиректов
            openAuth(navigate, { pathname: "/profile" }, { replace: true })
            return
        }
        setLoading(true)
        loadMessages().finally(() => setLoading(false))
    }, [user])

    if (loading) {
        return (
            <div className="flex justify-center py-16">
                <motion.div
                    className="size-10 rounded-full border-2 border-white/10 border-t-[#349be6]"
                    animate={{ rotate: 360 }}
                    transition={{ duration: 0.8, ease: "linear", repeat: Infinity }}
                />
            </div>
        )
    }

    return (
        <div className="flex flex-col gap-4">
            <h2
                className="text-white"
                style={{ fontFamily: DISPLAY, fontWeight: 800, fontSize: 24, letterSpacing: "-0.01em" }}>
                🔔 Уведомления
            </h2>

            {items.length === 0 ? (
                <div className="flex flex-col items-center gap-3 py-16 text-center">
                    <span className="text-[56px]">📭</span>
                    <p className="text-white/40 text-[15px]" style={{ fontFamily: BODY }}>
                        Уведомлений пока нет
                    </p>
                </div>
            ) : (
                <div className="flex flex-col gap-3">
                    {items.map((item, i) => (
                        <NotificationItem key={item.id} item={item} onRead={markAsRead} index={i} />
                    ))}
                </div>
            )}
        </div>
    )
}
